// extracted by mini-css-extract-plugin
module.exports = {"ruler":"Ruler_ruler__3tB5G","rulerMain":"Ruler_rulerMain__1JTQ0","rule":"Ruler_rule__3CXpe","interpretation":"Ruler_interpretation__1_3_o","iKnow":"Ruler_iKnow__19dkc"};